import { ServicePillar } from '../types/services';

export const servicePillars: ServicePillar[] = [
  {
    id: 'development-services',
    slug: 'development-services',
    title: 'Development Services',
    tagline: 'Custom Web, Mobile & Enterprise Systems Built for Scale',
    description: 'End-to-end engineering, cloud integration, and mobile application development tailored to your exact business requirements.',
    iconName: 'Code2',
    badgeText: 'Core Pillar #1',
    category: 'Development',
    isFeatured: true,
    items: [
      'Front-end and back-end programming',
      'Mobile app creation for iOS and Android',
      'UI / UX design and design systems',
      'Web platform and portal building',
      'Enterprise system integration & API microservices',
      'Quality assurance and automated testing',
      'Tech support and ongoing maintenance',
    ],
    metrics: [
      { label: 'System Uptime SLA', value: '99.9%' },
      { label: 'Delivery Efficiency', value: '+45%' },
    ],
  },
  {
    id: 'marketing-brand-support',
    slug: 'marketing-brand-support',
    title: 'Marketing & Brand Support',
    tagline: 'Elevate Your Digital Identity & High-Converting Assets',
    description: 'Strategic visual branding, 3D architectural modeling, and high-impact media assets designed to convert audiences into loyal clients.',
    iconName: 'Sparkles',
    badgeText: 'Core Pillar #2',
    category: 'Marketing',
    isFeatured: false,
    items: [
      'Brand identity, logo, and graphic design systems',
      'High-definition video production & motion design',
      '3D architectural modeling & spatial visualization',
      'Social media support & content creation',
      'CRM updates and campaign assistance',
    ],
    metrics: [
      { label: 'Brand Lift Rate', value: '3.4x' },
      { label: 'Asset Engagement', value: '+80%' },
    ],
  },
  {
    id: 'lead-generation-sales',
    slug: 'lead-generation-sales',
    title: 'Lead Generation & Sales Support',
    tagline: 'Predictable Revenue Pipelines & Qualified Appointments',
    description: 'Data-driven outbound prospecting and appointment setting campaigns that fill your pipeline with high-value decision makers.',
    iconName: 'TrendingUp',
    badgeText: 'Core Pillar #3',
    category: 'LeadGen',
    isFeatured: false,
    items: [
      'Targeted B2B prospecting & list curation',
      'Strategic cold calling & outbound engagement',
      'High-converting appointment setting & calendar booking',
      'Sales funnel tracking & pipeline management',
    ],
    metrics: [
      { label: 'Qualified Pipeline', value: '4.2x' },
      { label: 'Conversion Rate', value: '28%' },
    ],
  },
  {
    id: 'admin-operation-support',
    slug: 'admin-operation-support',
    title: 'Admin & Operation Support',
    tagline: 'Streamlined Back-Office & Flawless Operational Execution',
    description: 'Dedicated administrative oversight, calendar management, and operational reporting that give leadership back valuable focus hours.',
    iconName: 'Briefcase',
    badgeText: 'Core Pillar #4',
    category: 'AdminOps',
    isFeatured: false,
    items: [
      'Executive calendar management & meeting coordination',
      'Inbox oversight & high-priority communication filtering',
      'Operational reporting, dashboards, and data hygiene',
      'Workflow optimization & process documentation',
    ],
    metrics: [
      { label: 'Executive Hours Saved', value: '25+/wk' },
      { label: 'Process SLA Compliance', value: '99.5%' },
    ],
  },
];
